angular.module('NumbersEditor').controller('EventController', [
    '$scope', 'EventFactory', '$routeParams', '$rootScope', '$filter', '$dialogs', 'authFactory', 'GameFactory', '$location', 'appInfoFactory',
    function ($scope, eventFactory, $routeParams, $rootScope, $filter, $dialogs, authFactory, gameFactory, $location, appInfoFactory) {

        function setDatesForAuthorization() {
            if ($scope.Event == null) return;

            var eventStartDate = new Date($scope.Event.EventTime);
            eventStartDate.setHours(0, 0, 0, 0);
            $scope.EventStartDate = eventStartDate;

            appInfoFactory.getDateTime().success(function (dateTime) {
                var today = new Date(JSON.parse(dateTime));
                today.setHours(0, 0, 0, 0);
                $scope.Today = today;

                var tomorrow = new Date(today.getTime());
                tomorrow.setDate(tomorrow.getDate() + 1);
                tomorrow.setHours(0, 0, 0, 0);
                $scope.Tomorrow = tomorrow;

                var yesterday = new Date(today.getTime());
                yesterday.setDate(yesterday.getDate() - 1);
                yesterday.setHours(0, 0, 0, 0);
                $scope.Yesterday = yesterday;

                var daybeforeyesterday = new Date(today.getTime());
                daybeforeyesterday.setDate(daybeforeyesterday.getDate() - 2);
                daybeforeyesterday.setHours(0, 0, 0, 0);
                $scope.DayBeforeYesterday = daybeforeyesterday;
            }).error(function (error) {
                $.message(error.ExceptionMessage, MessageType.Error);
            });
        };

        function isTomorrowGame() {
            return $scope.Tomorrow && $scope.EventStartDate.valueOf() >= $scope.Tomorrow.valueOf();
        }

        function isTodayGame() {
            return $scope.Today && $scope.EventStartDate.valueOf() == $scope.Today.valueOf();
        };

        function isYesterdayGame() {
            return $scope.Yesterday && $scope.EventStartDate.valueOf() == $scope.Yesterday.valueOf();
        };

        function isDayBeforeYesterday() {
            return $scope.DayBeforeYesterday && $scope.EventStartDate.valueOf() <= $scope.DayBeforeYesterday.valueOf();
        };

        function generateDrawNumberList() {

            var drawNumberList = Enumerable.From($scope.Event.ResultPlaces)
                //.Where(function (x) { return x.BonusNumber == "N"; })
                .OrderBy(function (x) { return x.DrawnOrder; })
                .Select(function (x) { return x.Drawn; }).ToArray();
            return drawNumberList;

            /*var bonusNumber = Enumerable.From($scope.Event.ResultPlaces)
                .Where(function (x) { return x.BonusNumber == "Y"; })
                .Select(function (x) { return x.Drawn; }).ToArray();

            return drawNumberList.toString() + " Bonus " + bonusNumber.toString();*/
        };

        function getEvent() {
            eventFactory.GetEvent($routeParams.eventId)
                .success(function (event) {
                    $scope.Event = event;
                    bindDefaultResultPlaces();
                    setupNavPills();
                    $scope.Event.ResultPlaces.IsValid = true;
                    setDatesForAuthorization();
                    $rootScope.SetAppTitle("Event", getSubTitle());
                })
                .error(function (error) {
                    $.message(error.ExceptionMessage, MessageType.Error);
                });
        }

        function bindDefaultResultPlaces() {

            if ($scope.Event.ResultPlaces.length == 0) {
                for (var i = 0; i < $scope.Event.Game.ResultPlaces; i++) {
                    var resultPlace = {
                        DrawnOrder: i + 1,
                        Drawn: null,
                        BonusNumber: "N",
                        IsValid: true
                    };
                    $scope.Event.ResultPlaces.push(resultPlace);

                }
                if ($scope.Event.BonusNumber === 'Y') {
                    var bonusResultPlace = {
                        DrawnOrder: 0,
                        Drawn: null,
                        BonusNumber: "Y",
                        IsValid: true
                    };
                    $scope.Event.ResultPlaces.push(bonusResultPlace);
                }
            }
        };

        function setupNavPills() {

            $scope.NavPills = new Array();
            var lightWeightEvents = $scope.Event.LightWeightEvents;

            if ($scope.Event.SportCode === "IL") {
                lightWeightEvents.sort(function (a, b) { return b.Id - a.Id; });
            }

            for (var i = 0; i < lightWeightEvents.length; i++) {
                var active = "";
                if (lightWeightEvents[i].Id === parseInt($routeParams.eventId))
                    active = "event-navigation__pill--active active";

                var eventName = lightWeightEvents[i].Title === null ? "Event " + (i + 1) : lightWeightEvents[i].Title;
                if ($scope.Event.SportCode === "49" && i === 0) {
                    eventName = "Lunch Time";
                } else if ($scope.Event.SportCode === "49" && i === 1) {
                    eventName = "Tea Time";
                }

                var navPill = {
                    EventId: lightWeightEvents[i].Id,
                    EventName: eventName,
                    URL: "#event/" + lightWeightEvents[i].Id + "?sportCode=" + $routeParams.sportCode + "&startDate=" + $routeParams.startDate + "&no=" + (i + 1),
                    CssClass: active
                }
                $scope.NavPills.push(navPill);
            }
        };

        function getSubTitle() {
            var manageEvent = "Manage Event";
            var date = $filter("date")($scope.Event.EventTime, "fullDate");

            return $scope.Event.Game.Description + " - " + manageEvent + " (" + date + ")";
        }

        function isTodayOrYesterdayGame() {
            return $scope.Event != null
                && !isTomorrowGame()
                && !isDayBeforeYesterday()
                && (isTodayGame() || isYesterdayGame())
        }

        function isBroadcastNotStarted() {
            return $scope.Event.BroadcastStatus == null
        }

        function isBroadcasting() {
            return $scope.Event.BroadcastStatus == "S"
        }

        function init() {
            $scope.releasedTime = {
                hours: "",
                minutes: "",
                seconds: ""
            }
            $scope.isAdmin = authFactory.GetAuthenticationData().isAdmin;
            $scope.isTechSuper = authFactory.GetAuthenticationData().isTechSuper;
            getEvent();
        }

        $scope.IsStepByStepOn = $.IsStepByStepOn();
        $scope.DisplayEventInfoButton = $scope.IsStepByStepOn === false;

        if ($scope.IsStepByStepOn) {
            eventFactory.GetPreDrawValidation($routeParams.eventId)
                .success(function (preDrawValidation) {
                    $scope.DisplayNavigateToPublishResultPageButton = preDrawValidation.HasResulted || preDrawValidation.HasResultPublished;
                    if (preDrawValidation.HasPreDrawWeightCompleted === false) {
                        $location.path("/predrawweight/" + $routeParams.eventId);
                    } else if (preDrawValidation.HasPreDrawWeightCompleted === true && preDrawValidation.HasPreDrawCertificateCompleted === false) {
                        $location.path("/certificate/" + $routeParams.eventId);
                    } else if (preDrawValidation.HasPreDrawWeightCompleted === true && preDrawValidation.HasPreDrawCertificateCompleted === true) {
                        init();
                    }
                })
                .error(function (error) {
                    $.message(error.ExceptionMessage, MessageType.Error);
                });
        } else {
            init();
        }


        $scope.Active = function () {
            var dlg = $dialogs.confirm('Please Confirm', 'Are you sure you want to Active this event?');
            dlg.result.then(function (btn) {
                eventFactory.Active($routeParams.eventId)
                    .success(function () {
                        $scope.Event.ReleaseTime = null;
                        $scope.Event.Status = "A";
                        $scope.Event.statusMessage = "Active";
                        $.message(MessageText.EventSuccessfullyActivated, MessageType.Success);
                    })
                    .error(function (error) {
                        $.message(error.ExceptionMessage, MessageType.Error);
                    });
            });
        };
        $scope.CanActive = function () {
            if ($scope.Event == null) return false;
            return ($scope.Event.Status == "I" || $scope.Event.Status == "C" || $scope.Event.Status == "O" || $scope.Event.Status == "S");
        };

        $scope.CanRelease = function () {
            if (isTodayOrYesterdayGame()) {
                if ($scope.Event.Status === "I" || $scope.Event.Status === "R" || $scope.Event.Status === "V" || $scope.Event.Status === "C") {
                    return false;
                } else {
                    return true;
                }
            }
            return false;
        };

        $scope.CanStartBroadcast = function () {
            const allowedToStartStatusCodes = ["I", "A", "O"]
            return isTodayOrYesterdayGame()
                && allowedToStartStatusCodes.indexOf($scope.Event.Status) != -1
                && isBroadcastNotStarted()
        };

        $scope.CanEndBroadcast = function () {
            return isTodayOrYesterdayGame() && isBroadcasting()
        };

        $scope.StartBroadcast = function () {
            eventFactory.StartBroadcast($routeParams.eventId)
                .success(function () {
                    $scope.Event.BroadcastStatus = "S";
                    $.message(MessageText.EventSuccessfullyStarted, MessageType.Success);
                })
                .error(function (error) {
                    $.message(error.ExceptionMessage, MessageType.Error);
                });
        };

        $scope.EndBroadcast = function () {
            eventFactory.EndBroadcast($routeParams.eventId)
                .success(function () {
                    $scope.Event.BroadcastStatus = "C";
                    $.message(MessageText.EventSuccessfullyEnded, MessageType.Success);
                })
                .error(function (error) {
                    $.message(error.ExceptionMessage, MessageType.Error);
                });
        };

        $scope.Cancel = function () {
            var dlg = $dialogs.confirm('Please Confirm', 'Are you sure you want to cancel this event?');
            dlg.result.then(function (btn) {
                eventFactory.Cancel($routeParams.eventId)
                    .success(function () {
                        $scope.Event.Status = "C";
                        $scope.Event.statusMessage = "Cancelled";
                        $.message(MessageText.EventSuccessfullyCancelled, MessageType.Success);
                    })
                    .error(function (error) {
                        $.message(error.ExceptionMessage, MessageType.Error);
                    });
            });

        };
        $scope.CanCancel = function () {
            if ($scope.Event == null) return false;
            if (isDayBeforeYesterday()) return false;

            if (isTodayGame() || isYesterdayGame() || isTomorrowGame()) {
                return ($scope.Event.Status == "A");
            }

            return false;

        };

        $scope.Suspend = function () {
            var dlg = $dialogs.confirm('Please Confirm', 'Are you sure you want to suspend this event?');
            dlg.result.then(function (btn) {
                eventFactory.Suspend($routeParams.eventId)
                    .success(function () {
                        $scope.Event.Status = "S";
                        $scope.Event.statusMessage = "Suspended";
                        $scope.Event.ReleaseTime = null;
                        $.message(MessageText.EventSuccessfullySuspended, MessageType.Success);
                    })
                    .error(function (error) {
                        $.message(error.ExceptionMessage, MessageType.Error);
                    });
            });
        };
        $scope.CanSuspend = function () {
            if ($scope.Event == null) return false;
            if (isTomorrowGame()) return false;
            if (isTodayGame() || isYesterdayGame()) {
                return ($scope.Event.Status == "O");
            }
            if (isDayBeforeYesterday() && $scope.isAdmin) {
                return ($scope.Event.Status == "O");
            }

            return false;
        };

        $scope.ChangePending = function () {
            var dlg = $dialogs.confirm('Please Confirm', 'Are you sure you want to change the status of this event to Change Pending?');
            dlg.result.then(function (btn) {
                eventFactory.ChangePending($routeParams.eventId)
                    .success(function () {
                        $scope.DisplayNavigateToPublishResultPageButton = false;
                        $scope.Event.Status = "P";
                        $scope.Event.statusMessage = "Change Pending";
                        $.message(MessageText.EventSuccessfullyChangePending, MessageType.Success);
                    })
                    .error(function (error) {
                        $.message(error.ExceptionMessage, MessageType.Error);
                    });
            });
        };
        $scope.CanChangePending = function () {
            if ($scope.Event == null) return false;
            if (isTomorrowGame()) return false;

            if (isTodayGame() || isYesterdayGame()) {
                return ($scope.Event.Status == "R");
            }

            if (isDayBeforeYesterday() && $scope.isAdmin) {
                return ($scope.Event.Status == "R");
            }

            return false;

        };

        $scope.Void = function () {
            var dlg = $dialogs.confirm('Please Confirm', 'Are you sure you want to void this event?');
            dlg.result.then(function (btn) {
                eventFactory.Void($routeParams.eventId)
                    .success(function () {
                        $scope.Event.Status = "V";
                        $scope.Event.statusMessage = "Void";
                        $.message(MessageText.EventSuccessfullyVoided, MessageType.Success);
                    })
                    .error(function (error) {
                        $.message(error.ExceptionMessage, MessageType.Error);
                    });
            });
        };
        $scope.CanVoid = function () {
            if ($scope.Event == null) return false;
            if (isTomorrowGame()) return false;
            if ($scope.isAdmin === false) return false;

            if (isTodayGame() || isYesterdayGame() || isDayBeforeYesterday()) {
                return ($scope.Event.Status === "A" || $scope.Event.Status === "P" || $scope.Event.Status === "S");
            }

            return false;
        };

        $scope.SaveResult = function () {
            var drawNumbers = generateDrawNumberList();
            var dlg = $dialogs.confirmResults('Please Confirm', drawNumbers, $scope.Event.BonusNumber);

            dlg.result.then(function (btn) {
                eventFactory.SaveResult($routeParams.eventId, $scope.Event.ResultPlaces)
                    .success(function (event) {
                        $scope.Event = event;
                        $scope.Event.ResultPlaces.IsValid = true;
                        $dialogs.Information($routeParams.eventId, $scope.Event.GameId);
                    })
                    .error(function (error) {
                        $.message(error.ExceptionMessage, MessageType.Error);
                    });
            });
        };
        $scope.CanResult = function () {
            if ($scope.Event == null) return false;
            if (isTomorrowGame()) return false;

            if (isTodayGame() || isYesterdayGame()) {
                return ($scope.Event.Status == "O" || $scope.Event.Status == "P" || $scope.Event.Status == "X");
            }
            if (isDayBeforeYesterday() && $scope.isAdmin) {
                return ($scope.Event.Status == "O" || $scope.Event.Status == "P");
            }
            return false;

        }

        $scope.validate = function () {

            $scope.Event.ResultPlaces.IsValid = true;
            for (var k = 0; k < $scope.Event.ResultPlaces.length; k++) {
                $scope.Event.ResultPlaces[k].IsValid = true;
            }

            var notNullResultPlaces = Enumerable.From($scope.Event.ResultPlaces)
                .Where(function (x) { return x.Drawn != null; })
                .ToArray();

            for (var i = 0; i < notNullResultPlaces.length; i++) {

                var resultPlace = notNullResultPlaces[i];
                resultPlace.ErrorMessage = "";
                resultPlace.IsValid = true;

                if (isNaN(resultPlace.Drawn) === true) {
                    resultPlace.ErrorMessage = "Result is not a number";
                    resultPlace.IsValid = false;
                    $scope.Event.ResultPlaces.IsValid = false;
                }

                var drawNumber = parseInt(resultPlace.Drawn);
                if (drawNumber < $scope.Event.Minima || drawNumber > $scope.Event.Maxima) {
                    resultPlace.ErrorMessage = "Result not in the expected range";
                    resultPlace.IsValid = false;
                    $scope.Event.ResultPlaces.IsValid = false;
                }

                var resultPlaces = Enumerable.From($scope.Event.ResultPlaces)
                    .Where(function (x) { return x.DrawnOrder != resultPlace.DrawnOrder && x.Drawn != null; })
                    .ToArray();

                for (var j = 0; j < resultPlaces.length; j++) {
                    if (resultPlaces[j].Drawn == drawNumber) {
                        resultPlace.ErrorMessage = "Duplicate result places are not allowed";
                        resultPlace.IsValid = false;
                        $scope.Event.ResultPlaces.IsValid = false;
                    }
                }
            }
        };
        $scope.GoHome = function () {
            $location.path("game/" + $scope.Event.GameId).search({ sportCode: $scope.Event.SportCode, startDate: $scope.Event.EventTime });
        };

        $scope.ShowEventInfoModal = function () {
            $dialogs.EventInfo($scope.Event.SportCode);
        };

        $scope.ShowReleaseTimeModal = function () {
            $dialogs.ReleaseTime();
        };

        $scope.ShowPreDrawCertificateModal = function () {
            $dialogs.PreDrawCertificate();
        }

        $scope.GoToPublishResult = function () {
            $location.path("publishresults/" + $routeParams.eventId).search({ sportCode: $routeParams.sportCode, startDate: $routeParams.startDate, gameId: $routeParams.gameId, no: $routeParams.no });
        }


    }
]);